"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT = void 0;
const toastr_1 = __importDefault(require("toastr"));
require("jquery-ui/ui/widgets/spinner");
const locale_1 = require("~/services/locale");
const ga_1 = __importDefault(require("~/services/ga"));
/**
 * Configurations par défaut.
 */
exports.DEFAULT = {
    paper: 'a4',
    orientation: 'portrait',
    margin_left: 1.3,
    margin_right: 1.3,
    margin_top: 1.3,
    margin_bottom: 1.3,
    height_count: 1,
    width_count: 1,
};
/**
 * Formulaire de mise en page.
 * @constructor
 *
 * @param formId: L'identifiant du formulaire
 */
class FormatterForm {
    constructor(formId, permalink) {
        this.permalink = permalink;
        const $form = this.$el = $("#" + formId);
        // Ne rien faire à la soumission du formulaire
        $form.on("submit", e => e.preventDefault());
        // Soumision automatique à chaque changement
        const submit = () => this.$el.trigger("submit");
        $('input', $form).on("change", submit);
        $('select', $form).on("change", submit).on("keypress", submit);
        // Changement dynamiquement l'affichage des options custom des marges
        // en fonction des choix de l'utilisateur
        const updateMargesOptions = () => {
            switch ($('select[name=custom-marges]', this.$el).val()) {
                case '1': // Marges personnalisées
                    $('#custom-marges-options', this.$el).show('blind', {}, 200);
                    break;
                case '0': // Marges par défaut
                default:
                    $('#custom-marges-options', this.$el).hide('blind', {}, 200);
            }
        };
        $('select[name=custom-marges]', $form).on("change", updateMargesOptions).on("keypress", updateMargesOptions);
        // Spinner
        $('#page-count-selector input', $form).spinner({
            min: 1,
            max: 12,
            stop: submit
        });
        // Bouton Imprimer
        $('#print-button').on("click", () => {
            var url = this.permalink.buildUrl('print');
            window.open(url);
            // Google analytics
            ga_1.default.logEvent("Map: PrintPreview");
            return false;
        });
    }
    /**
     * Initialise le formulaire avec les données par défaut, ou celles qui proviennent
     * de l'url.
     *
     * @param {Object} settings
     * 				 La configuration du formulaire à initialiser.
     */
    setSettings(settings) {
        // Initialisation du formulaire
        var isMargeCustom = (settings.margin_left != exports.DEFAULT.margin_left
            || settings.margin_right != exports.DEFAULT.margin_right
            || settings.margin_top != exports.DEFAULT.margin_top
            || settings.margin_bottom != exports.DEFAULT.margin_bottom);
        $('select[name=paper]', this.$el).val([settings.paper]);
        $('input[name=orientation]', this.$el).val([settings.orientation]);
        $('input[name=left]', this.$el).val(settings.margin_left);
        $('input[name=right]', this.$el).val(settings.margin_right);
        $('input[name=top]', this.$el).val(settings.margin_top);
        $('input[name=bottom]', this.$el).val(settings.margin_bottom);
        $('select[name=custom-marges]', this.$el).val(isMargeCustom ? ['1'] : ['0']);
        $('input[name=height-count]', this.$el).val(settings.height_count);
        $('input[name=width-count]', this.$el).val(settings.width_count);
        // On initialise l'affichage ou non des options
        if (isMargeCustom) {
            $('#custom-marges-options', this.$el).show();
        }
        else {
            $('#custom-marges-options', this.$el).hide();
        }
    }
    ;
    /**
     * Récupération des données du formulaire.
     * Ces données sont récupérées telles quelles. S'il y a des restrictions à appliquer,
     * le formulaire devra être updaté avant l'appel à getSettings.
     *
     * @returns {Object} Les données du formulaire.
     */
    getSettings() {
        var defaultMarges = ($('select[name=custom-marges]', this.$el).val() == '0');
        var settings = {
            paper: $('select[name=paper]', this.$el).val(),
            orientation: $('input[name=orientation]:checked', this.$el).val(),
            margin_left: defaultMarges ? exports.DEFAULT.margin_left
                : parseFloat($('input[name=left]', this.$el).val()),
            margin_right: defaultMarges ? exports.DEFAULT.margin_right
                : parseFloat($('input[name=right]', this.$el).val()),
            margin_top: defaultMarges ? exports.DEFAULT.margin_top
                : parseFloat($('input[name=top]', this.$el).val()),
            margin_bottom: defaultMarges ? exports.DEFAULT.margin_bottom
                : parseFloat($('input[name=bottom]', this.$el).val()),
            scale: $("select[name='scale']", this.$el).val(),
            height_count: parseInt($("input[name='height-count']", this.$el).val()),
            width_count: parseInt($("input[name='width-count']", this.$el).val()),
        };
        return settings;
    }
    ;
    /**
     * Met à jour le formulaire pour autoriser ou non la résolution double.
     */
    updateRestrictions(restrictions) {
        var hasChanged = false;
        // Restriction du format de papier
        if (restrictions.limitSizeToA4) {
            // On interdit les formats > A4
            $('#paper-lock', this.$el).css('display', 'inline-block');
            var title = $('#paper-lock', this.$el).attr('title');
            var options = [$('select[name=paper] option[value=a3]', this.$el),
                $('select[name=paper] option[value=a2]', this.$el),
                $('select[name=paper] option[value=a1]', this.$el),
                $('select[name=paper] option[value=a0]', this.$el)];
            for (var i = 0, l = options.length; i < l; i++) {
                options[i]
                    .attr('disabled', 'disabled')
                    .attr('title', title);
            }
            // Si besoin, on choisit la sélection à A4
            if ($('select[name=paper] option:selected', this.$el).attr('disabled') == 'disabled') {
                $('select[name=paper]').val('a4');
                hasChanged = true;
            }
        }
        else {
            // Tous les formats sont autorisés
            $('#paper-lock', this.$el).hide();
            var options = [$('select[name=paper] option[value=a3]', this.$el),
                $('select[name=paper] option[value=a2]', this.$el),
                $('select[name=paper] option[value=a1]', this.$el),
                $('select[name=paper] option[value=a0]', this.$el)];
            for (var i = 0, l = options.length; i < l; i++) {
                options[i].removeAttr('disabled')
                    .removeAttr('title');
            }
        }
        // Si on a modifié les choix de l'utilisateur
        if (hasChanged) {
            toastr_1.default.info((0, locale_1.t)('formatterFrom.sizeRestriction'));
        }
    }
    ;
    /**
     * Met à jour la liste des échelles disponibles au travers du formulaire
     *
     * @param {array} scales: les échelles disponibles
     */
    updateScales(scales) {
        const $scales = $("select[name='scale']", this.$el);
        // On retire les ancielles options
        $('option', $scales).remove();
        // On met en place les nouvelles options
        for (const scale of scales) {
            var formattedScale = scale.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            $scales.append($(`<option value ="${scale}">1 : ${formattedScale}'</option>`));
        }
    }
}
exports.default = FormatterForm;
